'use strict';

/**
 * When keying a value into a number input which exceeds `mac`, set it to max
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stNumberInputRevertToMax
 * @description
 * # stNumberInputRevertToMax
 */
angular.module('360StoreAngularApp')
	.directive('stNumberInputRevertToMax', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModelCtrl) {
				const max = parseInt(attrs.max, 10);
				if (isNaN(max)) {
					return;
				}
				ngModelCtrl.$parsers.push(function (viewValue) {
					const valueAsNumber = parseInt(viewValue, 10);

					if (!isNaN(valueAsNumber) && valueAsNumber > max) {
						ngModelCtrl.$setViewValue(max);
						ngModelCtrl.$render();
						return max;
					} else {
						return viewValue;
					}
				});
			}
		};
	});
